import { useTranslation } from "@fmc-digital/i18n";
import { Text } from "@fmc-digital/ui";
import type { MFAResendLinkProps } from "./mfa-resend-link.types";

/**
 * MFAResendLink Molecule
 * Displays resend link when wait period has elapsed
 */
export function MFAResendLink({ waitSeconds, onResend }: Readonly<MFAResendLinkProps>) {
  const { t } = useTranslation();

  if (waitSeconds > 0) {
    return (
      <Text variant="bodyMedium" className="mfa-wait-text" align="center">
        {t("auth.mfa.waitMessage", { seconds: 30 })}
      </Text>
    );
  }

  return (
    <Text variant="bodyMedium" className="mfa-wait-text" align="center">
      {t("auth.mfa.didntReceive")}{" "}
      <button type="button" onClick={onResend} className="mfa-resend-link ml-3">
        {t("auth.mfa.resendCode")}
      </button>
    </Text>
  );
}
